var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 74,
    viewBox: "0 0 82 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 3V71M57.8889 6.77778L41 21.8889L24.1482 6.77778M24.1482 67.2222L41 52.1111L57.8889 67.2222M3 37H79M7.22222 21.8889L24.1482 37L7.22222 52.1111M74.7778 52.1111L57.8889 37L74.7778 21.8889",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.acebc119bc0da599a287a813006bb9fe.svg";
export { ForwardRef as ReactComponent };